import type { ListBuilderList } from '../../../types';
import { createStandardOrderColumns } from '../columns';
import { ORDER_REQUIRED_FIELDS, SALES_REP_FILTER_RULES } from '../shared';

/**
 * Abandoned Carts list configuration
 * Unsubmitted orders from previous days that may need follow-up
 */
export const abandonedCartsList: ListBuilderList = {
	id: 'abandoned-carts',
	cacheTTL: 600000,
	name: 'Abandoned Carts',
	type: 'default',
	active: true,
	sortOrder: 5,
	requiredFeature: 'order-entry',
	columns: createStandardOrderColumns(),
	description: 'Unsubmitted orders from previous days that may need follow-up',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_REQUIRED_FIELDS,
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderDateRange: {
			defaultValue: [
				{
					id: 'until-yesterday',
					label: 'Until Yesterday',
					data: {
						startDate: null,
						endDate: '{{DATE:-1d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [
				{
					id: '1',
					label: 'Unsubmitted',
				},
			],
		},
		orderOrigin: {
			defaultValue: [
				{
					id: '1',
					label: 'CRM',
				},
				{
					id: '3',
					label: 'E-Commerce',
				},
			],
		},
	},
};
